/**
 * SignInForm.jsx
 * Created by michaelbray on 2/14/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../../../sharedComponents/icons/Icons';
import Loading from '../../../sharedComponents/Loading';
import NotificationsWrapper from '../../../notifications/NotificationsWrapper';

const propTypes = {
    disableAccountFeatures: PropTypes.bool,
    errorText: PropTypes.string,
    create: PropTypes.func,
    reset: PropTypes.func,
    confirmSignIn: PropTypes.func,
    mfaRequired: PropTypes.bool,
    mfaValidation: PropTypes.bool
};

export default class SignInForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            processing: false
        };

        this.emailTextChange = this.emailTextChange.bind(this);
        this.passwordTextChange = this.passwordTextChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    componentDidMount() {
        this.email.focus();
    }

    componentWillReceiveProps(newProps){
        if (newProps.errorText){
            this.setState({
                processing: false
            });
        }
    }

    emailTextChange(e) {
        this.setState({
            email: e.target.value
        });
    }

    passwordTextChange(e) {
        this.setState({
            password: e.target.value
        });
    }

    submitForm(e) {
        e.preventDefault();
        this.setState({
            processing: true
        })

        this.props.confirmSignIn({
            email: this.state.email,
            password: this.state.password
        });
    }

    render() {
        let error = null;
        let loading = null;
        if (this.state.processing) {
            loading = (
                <div className="rec-sign-loading">
                    <Loading />
                </div>
            )
        }

        if (this.props.errorText) {
            error = (
                <div className="rec-notification-error">
                    <span className="rec-notification-icon">
                        <Icons.IconError className="rec-icon-error" />
                    </span>
                    <div className="rec-notification-body">
                        <p>{this.props.errorText}</p>
                    </div>
                </div>
            );
        }

        let mfa = null;
        if (this.props.mfaRequired) {
            mfa = (
                <div className="rec-notification-warning">
                    <span className="rec-notification-icon">
                        <Icons.IconWarning className="rec-icon-warning" />
                    </span>
                    We don&apos;t recognize the device you&apos;re trying to login from. Please check your email to verify your identity and authorize this device.
                </div>
            );
        }

        let mfaValidationText = null;
        let reset = null;
        let create = null;
        if (this.props.mfaValidation) {
            mfaValidationText = (
                <div className="rec-notification-info">
                    <span className="rec-notification-icon">
                        <Icons.IconInfo className="rec-icon-info" />
                    </span>
                    Your device has been successfully validated, please log in to complete this process.
                </div>
            );
        }
        else {
            reset = (
                <button
                    onClick={this.props.reset}
                    disabled={this.props.disableAccountFeatures}
                    className="rec-button-link"
                    title="Reset Password"
                    aria-label="Reset Password">
                    Reset Password
                </button>
            );
            create = (
                <div className="rec-acct-modal-footer">
                    <p>Don&apos;t have an account?</p>
                    <button
                        onClick={this.props.create}
                        disabled={this.props.disableAccountFeatures}
                        className="rec-button-link"
                        title="Sign Up"
                        aria-label="Sign Up">
                        Sign Up
                    </button>
                </div>
            );
        }

        let loginDisabled = null;
        if (this.props.disableAccountFeatures) {
            loginDisabled = (
                <NotificationsWrapper noticeType="error" closeButton={false}>
                    <div className="rec-notification-title">This is a BETA site. Please be aware
                        that you cannot make or change any reservations in this BETA version of
                        the site, nor can you log in to your account or create a new one.
                    </div>
                </NotificationsWrapper>
            );
        }

        let oldAccountWarning = null;
        if (!this.props.disableAccountFeatures) {
            oldAccountWarning = (
                <div className="rec-legacy-users-message">
                    <NotificationsWrapper noticeType="warning">
                        <p>You&#39;ve likely noticed we&#39;ve made some big changes to our site. One of those changes includes updating account security. Don&#39;t worry, we&#39;ve saved your Recreation.gov account. However, your old password won&#39;t work on our new site. You can access your account by clicking &#34;Reset Password&#34; below to reset your password.
                        </p>
                    </NotificationsWrapper>
                </div>
            );
        }

        return (
            <div>
                <div className="rec-modal-title">Log In</div>
                {loginDisabled}
                {loading}
                {error}
                {mfa}
                {mfaValidationText}
                <form onSubmit={this.submitForm}>
                    <div className="form-item-wrap">
                        <label
                            htmlFor="rec-acct-sign-in-email-address"
                            className="rec-sr-only">
                            Email Address
                        </label>
                        <input
                            id="rec-acct-sign-in-email-address"
                            disabled={this.props.disableAccountFeatures}
                            ref={(email) => this.email = email}
                            onChange={(event) => this.emailTextChange(event)}
                            placeholder="Email Address"
                            className="rec-acct-email" />
                        <div className="form-item-icon-holder">
                            <Icons.IconEmail className="rec-icon-email" />
                        </div>
                    </div>
                    <div className="form-item-wrap">
                        <label
                            htmlFor="rec-acct-sign-in-password"
                            className="rec-sr-only">
                            Password
                        </label>
                        <input
                            id="rec-acct-sign-in-password"
                            disabled={this.props.disableAccountFeatures}
                            type="password"
                            ref={(password) => this.password = password}
                            onChange={(event) => this.passwordTextChange(event)}
                            placeholder="Password"
                            className="rec-acct-password"
                            autoComplete="off" />
                        <div className="form-item-icon-holder">
                            <Icons.IconLock className="rec-icon-lock" />
                        </div>
                    </div>
                    <button
                        disabled={this.state.processing || this.props.disableAccountFeatures}
                        className="rec-button-primary"
                        title="Log In"
                        aria-label="Log In">
                        Log In
                    </button>
                    {oldAccountWarning}
                </form>
                {reset}
                {create}
            </div>
        );
    }
}

SignInForm.propTypes = propTypes;
